var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpuLimiterDisabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 61,
    viewBox: "0 0 57 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CPU Limiter_ON",
    clipPath: "url(#clip0_282_4897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 3.8833V15.1333L32.25 15.1333L32.25 3.8833L36 3.8833Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 45.1333V56.3833H32.25L32.25 45.1333H36Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.375 28.2583H17.25V32.0083H0.375V28.2583Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.75 28.2583H56.625V32.0083H39.75V28.2583Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 3.8833L24.75 15.1333L21 15.1333L21 3.8833L24.75 3.8833Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 45.1333L24.75 56.3833H21L21 45.1333H24.75Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.25 11.3833H9.75V48.8833H47.25V11.3833ZM6 7.6333V52.6333H51V7.6333H6Z",
    fill: "#5C4E7E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.75 18.8833H17.25V41.3833H39.75V18.8833ZM13.5 15.1333V45.1333H43.5V15.1333H13.5Z",
    fill: "#5C4E7E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_4897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.25,
    height: 60,
    fill: "white",
    transform: "translate(0.375 0.133301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuLimiterDisabledMain);
export default __webpack_public_path__ + "static/media/cpuLimiterDisabledMain.7e04fe496005942509a7ed40201e9b61.svg";
export { ForwardRef as ReactComponent };